import ApiMicroService from './request-micro-service'
import axios from 'axios'
import {RequestInvoice} from "../constants/interface";
import {getHeaders} from "../func/common";
import ApiService from "./request-service";

export const getInfoPartner = async (data: any) => {
    try {
        const result = await ApiMicroService.post('payment-service/check-session', data)
        return result.data
    } catch (e) {
        throw e
    }
}

export const getCompanyByTaxCode = async (taxCode: string) => {
    try {
        const results = await axios.get(`https://app.meinvoice.vn/other/getcompanyinfobytaxcode?taxcode=${taxCode}`)
        return results.data
    } catch (e) {
        throw e
    }
}

export const getInvoiceByOrderToken = async (order_token: string) => {
    try {
        const results = await ApiMicroService.get(`/core-accounting/invoice/${order_token}`)
        return results.data
    } catch (e) {
        throw e
    }
}

export const sendRequestInvoice = async (data: RequestInvoice) => {
    try {
        const results = await ApiMicroService.put('/core-accounting/invoice', data)
        return results.data
    } catch (e) {
        throw e
    }
}

export const getUserProfile = async () => {
    try {
        const results = await ApiMicroService.get('/core-user-service/person/profile', {
            headers: getHeaders()
        })
        return results.data
    } catch (e) {
        throw e
    }
}

export const addSubscriber = async (data: any) => {
    try {
        const results = await ApiService.post('/users/add-subscriber/', data, {
            headers: getHeaders(),
        })
        return results.data
    } catch (e) {
        throw e
    }
}
